import axios from "axios";

// Crear instancia de axios específica para OTP
export const otpApi = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND}api/otp`, // Endpoint base para OTP
  headers: {
    "Content-Type": "application/json",
  },
});

// Interceptor para requests (opcional, por si necesitas configuración adicional)
otpApi.interceptors.request.use(
  (config) => {
    // Puedes agregar headers adicionales aquí si necesitas
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Interceptor para responses (manejo de errores)
otpApi.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // Manejo centralizado de errores OTP
    if (error.response?.status === 429) {
      // Too Many Requests - límite de intentos excedido
      return Promise.reject(new Error("Demasiados intentos. Espera antes de intentar de nuevo."));
    }
    
    if (error.response?.status === 410) {
      // Gone - OTP expirado
      return Promise.reject(new Error("El código OTP ha expirado."));
    }
    
    if (error.response?.status === 404) {
      // Not Found - OTP no encontrado
      return Promise.reject(new Error("Código OTP inválido."));
    }
    
    return Promise.reject(error);
  }
);